import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledDatePicker = styled(DatePicker<Date>)(() => ({
  width: '320px',
  height: '56px',

  '.MuiInputBase-input': {
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },

  '.MuiYearPicker-root button, .MuiMonthPicker-root button, .MuiPickersDay-root button': {
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },

  '.MuiPaper-root': {
    marginLeft: '50px',
  },
}));
